import { PassThrough } from '@primevue/core'
import { PrimeVuePTOptions } from 'primevue'

/**
 * @unocss-include
 *
 * The pass-through options are used to pass the configuration directly to the PrimeVue components.
 * For overriding the default PrimeVue components, you can use the pass-through options,
 * instead of setting classes on the components in the template.
 *
 * See https://primevue.org/passthrough/ for more information
 */
export default {
  button: {
    label: {
      class: 'text-sm font-medium',
    },
  },
  card: {
    header: {
      class: 'px-4 pt-4',
    },
    root: {
      class: '!border-[#f1f1f4] border-solid border-1',
    },
  },
  breadcrumb: {
    root: {
      class: '!pl-0',
    },
  },
  contextmenu: {
    itemLabel: {
      class: 'py-0.5',
    },
  },
  datatable: {
    pcPaginator: {
      root: {
        class: 'text-base! w-full! justify-start!',
      },
      content: {
        class: 'w-full!',
      },
      current: {
        class: 'color-gray-400! font-semibold ml-auto!',
      },
      page: {
        class: 'color-gray-400! font-semibold rounded-md! ',
      },
      prevIcon: {
        class: 'color-gray-400! font-semibold',
      },
      nextIcon: {
        class: 'color-gray-600! font-semibold',
      },
    },
    column: {
      headerCell: {
        class: 'bg-stone-50/90! py-0!',
      },
      columnHeaderContent: {
        class: 'px-2',
      },
      sortIcon: {
        class: 'w-3! h-3!',
      },
      filterMenuIcon: {
        class: 'w-3! h-3!',
      },
      bodyCell: {
        class: 'px-2! text-base',
      },
      columnTitle: {
        class: 'text-base color-gray-600! font-400! py-2!',
      },
    },
  },
  tabs: {
    class: 'gap-y-2',
  },
  tab: {
    class: '!p-2',
  },
  tablist: {
    tabList: {
      class: '!bg-transparent',
    },
  },
  tag: {
    label: {
      class: 'text-sm font-medium',
    },
  },
  menu: {
    root: { class: 'px-1 flex flex-col' },
    start: { class: 'pt-5 pl-5.5 pb-10' },
    list: { class: '!px-5.5' },
    submenuLabel: { class: '!color-gray-400 text-0.8125rem !pb-1 !pt-3 !font-medium !px-0 uppercase tracking-tight' },
    item: { class: '!py-1 pl-1.12' },
    itemLink: { class: '!px-0 !py-1.5' },
    itemContent: { class: 'group/menu_item font-normal !bg-transparent' },
    itemIcon: { class: 'color-red-500 group-hover/!menu_item:color-primary-300 !menu_item:font-semibold' },
    itemLabel: { class: 'group-hover/!menu_item:color-primary-300 !menu_item:font-semibold' },
    end: { class: 'mt-auto py-2' },
  },
} as PassThrough<PrimeVuePTOptions>
